import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import * as CentrosCostoService from 'services/centrosCosto.service'

const CodigoFormGroup = ({ iError, iTouched, fIsSubmitting, maxLength, idNodoPadre, nivel }) => {
  const [codigoNodoPadre, setCodigoNodoPadre] = React.useState('')

  React.useEffect(() => {
    CentrosCostoService.obtenerxIsAsSoloCodigo(idNodoPadre)
      .then(({ data }) => {
        setCodigoNodoPadre(data.codigo)
      })
      .catch(() => setCodigoNodoPadre(''))
  }, [idNodoPadre])

  return (
    <Form.Group>
      <Form.Label text='CODIGO' htmlFor='input-codigo' md={4} alignRightAt='md' />
      {nivel === 2 && (
        <Col
          md={3}
          style={{
            paddingRight: '0'
          }}
        >
          <Form.InputText disabled id='input-prefijoCodigoCuenta' defaultValue={codigoNodoPadre} className='text-right' />
        </Col>
      )}
      <Col md={nivel === 2 ? 5 : 8}>
        <Field name='codigo'>
          {({ field }) => (
            <Form.InputText {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-codigo' maxLength={maxLength} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
